// extracted by mini-css-extract-plugin
module.exports = {"card":"MyTeam_card__ilso0","pfp":"MyTeam_pfp__uR6mJ","teamMemberPhoto":"MyTeam_teamMemberPhoto__2nbq_"};